import { InputNumber } from "antd";
import Button from "components/shared/button";
import { QuantityWidgetWrapper } from "./QuantityWidgetWrapper";

export const FreeNumberQuantityWidget: React.FC<{
  value?: number;
  max?: number;
  min?: number;
  onDecrease: () => void;
  onIncrease: () => void;
  onChange: (value?: number) => void;
}> = ({ value, max, min, onDecrease, onIncrease, onChange }) => {
  return (
    <QuantityWidgetWrapper isSelected={!!value}>
      <>
        <Button
          micro
          outline
          icon="remove"
          disabled={!value || value === min}
          onClick={onDecrease}
        />
        <InputNumber
          variant="borderless"
          controls={false}
          type="number"
          data-length="50"
          style={{
            fontSize: "18px",
            fontWeight: 400,
            color: "white",
          }}
          value={value}
          placeholder="0"
          max={max}
          min={0}
          onChange={() => onChange(value ?? undefined)}
        />
        <Button
          micro
          outline
          icon="add"
          disabled={!!max && (value as number) >= max}
          onClick={onIncrease}
        />
      </>
    </QuantityWidgetWrapper>
  );
};
